import Service, { Bootstrap } from '@hotmart/cas-js'
import type { AuthServiceInstance } from '@hotmart/cas-js/dist/auth.service'
import { PossibleStorages } from '@hotmart/cas-js/dist/auth.service'
import type { LogoutError } from '@space-lib-events/logout'
import { AuthUtils } from '@space-shell/common/utils/auth'

import { IS_HOTMART_DOMAIN } from '@space-shell/constant/domain'

import { CAS_FLOW, CAS_FLOW_STORAGE_KEY, DEFAULT_SETTINGS } from './constants'
import type { Start } from './types'

class AuthService {
  private _bootstrap: Bootstrap

  constructor() {
    const casFlow = sessionStorage.getItem(CAS_FLOW_STORAGE_KEY)
    const isSurrogate = casFlow === CAS_FLOW.SURROGATE
    const shouldRevalidate = IS_HOTMART_DOMAIN ? true : false

    const authServiceInstance: AuthServiceInstance = new Service({
      ...DEFAULT_SETTINGS,
      ...(isSurrogate && {
        authority: `${process.env.SURROGATE_URL}/oidc`,
        storeToUse: PossibleStorages.sessionStorage
      })
    })

    this._bootstrap = new Bootstrap(authServiceInstance, {
      appName: 'club',
      revalidateOnFocus: shouldRevalidate,
      revalidateOnStart: shouldRevalidate
    })
  }

  start({ signInRedirect }: Start = { signInRedirect: false }) {
    this._bootstrap.start({ signinRedirect: signInRedirect })
  }

  async signOut(error?: LogoutError) {
    AuthUtils.reset()

    await this._bootstrap.logout(error)
  }

  async silentRenew() {
    AuthUtils.reset()

    const user = await this._bootstrap.signinSilent()

    return user
  }

  async silentRenewCallback() {
    await this._bootstrap.authService.userManager.signinSilentCallback()
  }
}

export default new AuthService()
